import { gql } from '@apollo/client'

/**
 * Hands one admin-approved Workflow step to the Workflow Interpreter for the
 * session's conversation (storefront COM-1293).
 *
 * The answer says only that the trigger went out. The step's outcome arrives
 * later, through its own callback, and is read with the `workflowStepRequest`
 * query against the `requestId` returned here.
 *
 * Every refusal is an error, not a falsy `ok` — `ok` is always `true` when the
 * field resolves. The codes cinnamon can see, all as **string**
 * `extensions.code`, per the user API's `pushError`:
 *
 * - `404` — the switch is off for the storefront, the step is not listed in
 *   its `webviewSteps`, the session is inactive, or `orderUid` is not the
 *   customer's. One code for every miss, on purpose, so steps cannot be
 *   enumerated by probing.
 * - `413` — `params` is over 4096 bytes as JSON.
 * - `429` — more than 10 calls for the session in a minute.
 * - `424` — the interpreter refused the trigger, or it was never sent. The
 *   request is stored as `TRIGGER_FAILED`.
 *
 * ⚠️ **`sessionUid` is `String!` and `orderUid` is `ID`**, as the storefront
 * SDL declares them. `tests/mutation.test.ts` pins the variable types.
 * @internal
 */
const runWorkflowStepMutation = gql`
  mutation RunWorkflowStep(
    $storefrontName: String!
    $sessionUid: String!
    $step: String!
    $params: JSON
    $orderUid: ID
  ) {
    runWorkflowStep(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      step: $step
      params: $params
      orderUid: $orderUid
    ) {
      ok
      requestId
    }
  }
`

export default runWorkflowStepMutation
